<template>
  <div class="pc-token-infos">
    <div class="head flex-left">
      <img :src="infos.icon" />
      <span>{{ infos.symbol }}</span>
      <span v-if="infos.nickname">&nbsp;({{ infos.nickname }})</span>
    </div>
    <div class="infos table-shadow">
      <h3 class="title">概况</h3>
      <div class="detail">
        <div class="item">
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">发行总量</span>
            <span>{{ formatTotalSupply(infos) }}</span>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/blue.png" alt />
            <span class="item-title">合约地址</span>
            <!-- <span>{{ infos.address | filterHash }}</span> -->
            <router-link :to="`/contract/${infos.address}`" class="light">{{
              infos.address
            }}</router-link>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">锁仓总量</span>
            <span>{{ (infos.lockNum || 0).toLocaleString() }}</span>
          </p>
        </div>
        <div class="item">
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">精度</span>
            <span>{{ infos.decimals || '-' }}</span>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/blue.png" alt />
            <span class="item-title">发行时间</span>
            <span>{{ new Date(infos.deploy_time).getTime() | formatTime }}</span>
          </p>
        </div>
        <p class="item-text flex-left">
          <!-- <img src="../../../assets/img/tip/blue.png" alt />
          <span class="item-title">发行区块</span>
          <router-link :to="`/block/${infos.deploy_block_number}`" class="light">{{
            infos.deploy_block_number
          }}</router-link> -->
        </p>
        <!-- <div class="item">
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">小数点</span>
            <span>{{ infos.decimals || '-' }}</span>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/blue.png" alt />
            <span class="item-title">价值</span>
            <span>￥{{ Number(infos.rmb || 0).toFixed(2) }}</span>
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          icon: "",
          symbol: "",
          total: "",
          holders: "",
          txCount: "",
          createTime: "",
          ceilpoint: "",
          web: ""
        };
      }
    }
  },
  methods: {
    formatTotalSupply(infos) {
      // 优先使用格式化后的总供应量
      if (infos.total_formatted) {
        return Number(infos.total_formatted).toLocaleString();
      }
      // 如果有原始总供应量和小数位数，进行计算
      if (infos.total && infos.decimals) {
        const decimals = infos.decimals || 18;
        const total = Number(infos.total) / Math.pow(10, decimals);
        return total.toLocaleString();
      }
      return '-';
    }
  }
};
</script>


<style lang="scss" scoped>
.pc-token-infos {
  .head {
    margin: 30px 0 10px;
    font-size: 16px;
    color: $black;
    font-family: PingFangSC-Semibold;

    img {
      width: 30px;
      margin-right: 10px;
    }
  }

  .infos {
    width: 100%;
    background: $white;
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);

    .title {
      height: 70px;
      line-height: 70px;
      padding-left: 30px;
      font-size: 16px;
      color: $black;
      border-bottom: 1px solid #eee;
    }

    .detail {
      .item {
        display: inline-block;
        width: calc(1177px / 2);
        height: 100%;
        border-right: 1px solid #eee;
        padding: 10px 0 10px 30px;
        color: $black;
        font-size: 14px;

        .item-text {
          padding: 10px 0;

          .item-title {
            width: 96px;
            margin-left: 20px;
          }
        }
      }

      .item:last-child {
        border: none;
      }
    }
  }
}
</style>
